import { ProductOption } from "@repobit/dex-store";

export type UpdateByDelta = {
  type       : "devices" | "subscription";
  delta      : number | "next" | "prev";
  min?       : number;
  max?       : number;
  /**
   * If true, treat `delta` as the new absolute value
   * instead of adding/subtracting it.
   */
  useAsValue?: boolean;
  /**
   * Optional identifier of the action source element (data-store-id)
   */
  storeId?   : string;
}

export type Action = {
  id?          : string;
  campaign?    : string;
  bundle?      : boolean;
  devices?     : number;
  subscription?: number;
  /**
   * Optional identifier of the action source element (data-store-id)
   */
  storeId?     : string;
}

export type CollectUpdateByDelta = {
  name  : symbol | string,
  update: UpdateByDelta | null
};

export type CollectAction = {
  name  : symbol | string,
  action: Action | null
};

export type CollectOption = {
  name   : symbol | string,
  options: Promise<ProductOption[]> | null,
};

export class UpdateByDeltaEvent extends CustomEvent<UpdateByDelta> {
  static readonly eventName = "store-update-delta";

  constructor(detail: UpdateByDelta) {
    super(UpdateByDeltaEvent.eventName, {
      detail,
      bubbles   : true,
      composed  : true,
      cancelable: true
    });
  }
}

export class ActionEvent extends CustomEvent<Action> {
  static readonly eventName = "store-set-action";

  constructor(detail: Action) {
    super(ActionEvent.eventName, {
      detail,
      bubbles   : true,
      composed  : true,
      cancelable: true
    });
  }
}

export class CollectActionEvent extends CustomEvent<CollectAction> {
  static readonly eventName = "store-collect-action";

  constructor(detail: CollectAction) {
    super(CollectActionEvent.eventName, {
      detail,
      bubbles   : true,
      composed  : true,
      cancelable: true
    });
  }
}

export class CollectUpdateByDeltaEvent extends CustomEvent<CollectUpdateByDelta> {
  static readonly eventName = "store-collect-update-by-delta";

  constructor(detail: CollectUpdateByDelta) {
    super(CollectUpdateByDeltaEvent.eventName, {
      detail,
      bubbles   : true,
      composed  : true,
      cancelable: true
    });
  }
}

export class CollectOptionEvent extends CustomEvent<CollectOption> {
  static readonly eventName = "store-collect-option";

  constructor(detail: CollectOption) {
    super(CollectOptionEvent.eventName, {
      detail,
      bubbles   : true,
      composed  : true,
      cancelable: true
    });
  }
}

/**
 * Contextual child registration for updateComplete coordination.
 * Children dispatch these to their nearest StateNode-like parent.
 */
export type CollectChild = {
  child: HTMLElement;
};

export class CollectChildEvent extends CustomEvent<CollectChild> {
  static readonly eventName = "store-collect-child";

  constructor(detail: CollectChild) {
    super(CollectChildEvent.eventName, {
      detail,
      bubbles   : true,
      composed  : true,
      cancelable: true
    });
  }
}

export class CollectChildRemovedEvent extends CustomEvent<CollectChild> {
  static readonly eventName = "store-collect-child-removed";

  constructor(detail: CollectChild) {
    super(CollectChildRemovedEvent.eventName, {
      detail,
      bubbles   : true,
      composed  : true,
      cancelable: true
    });
  }
}

export type EventType =
    UpdateByDeltaEvent |
    ActionEvent;
